import Vue from 'vue'

Vue.prototype.$statusCode = {

  /* 409 http status */
  phoneNotVerified: 'PHONE_NOT_VERIFIED',
  smsCodeExpired: 'SMS_CODE_EXPIRED',
  smsCodeNotFound: 'SMS_CODE_NOT_FOUND',
  phoneAlreadyVeryfied: 'PHONE_ALREADY_VERIFIED',
}
